import { render, staticRenderFns } from "./birth-confirm-order.vue?vue&type=template&id=4ca13b5c&scoped=true&"
import script from "./birth-confirm-order.vue?vue&type=script&lang=js&"
export * from "./birth-confirm-order.vue?vue&type=script&lang=js&"
import style0 from "./birth-confirm-order.vue?vue&type=style&index=0&id=4ca13b5c&prod&lang=scss&"
import style1 from "./birth-confirm-order.vue?vue&type=style&index=1&id=4ca13b5c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca13b5c",
  null
  
)

export default component.exports